
import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle, ShieldCheck } from "lucide-react";
import { WalletHeader } from "@/components/wallet/WalletHeader";
import { AccountOverview } from "@/components/wallet/AccountOverview";
import { TransactionActions } from "@/components/wallet/TransactionActions";
import { TransactionHistory } from "@/components/wallet/TransactionHistory";
import { useWallet } from "@/hooks/useWallet";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

const WalletPage = () => {
  const {
    isConnected,
    balance,
    walletAddress,
    isRefreshing,
    transactions,
    handleConnect,
    handleDeposit,
    handleWithdraw,
    handleRefresh
  } = useWallet();

  return (
    <div className="container mx-auto py-8 space-y-6">
      <WalletHeader
        isConnected={isConnected}
        isRefreshing={isRefreshing}
        onConnect={handleConnect}
        onRefresh={handleRefresh}
      />

      {isConnected && (
        <>
          <div className="flex items-center justify-between">
            <div className="text-sm text-gray-500">Last updated: {new Date().toLocaleTimeString()}</div>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <div className="flex items-center text-emerald-600 text-sm font-medium">
                    <ShieldCheck className="w-4 h-4 mr-1" />
                    <span>Secured Connection</span>
                  </div>
                </TooltipTrigger>
                <TooltipContent>
                  <p>Your connection is encrypted and secure</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <AccountOverview walletAddress={walletAddress} balance={balance} />
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <TransactionActions 
              balance={balance} 
              onDeposit={handleDeposit} 
              onWithdraw={handleWithdraw} 
            />
            <TransactionHistory transactions={transactions} />
          </div>

          <Card className="bg-blue-50 border-blue-100">
            <CardContent className="p-4 flex items-start gap-3">
              <AlertCircle className="w-5 h-5 text-blue-600 mt-0.5" />
              <div>
                <p className="text-sm text-blue-800">
                  <strong>Security Notice:</strong> Always verify transaction details before confirming. Never share your 
                  private keys or recovery phrases with anyone.
                </p>
              </div>
            </CardContent>
          </Card>
        </>
      )}
    </div>
  );
};

export default WalletPage;
